import { indexedDBManager } from '@creanizer/utils'

export async function migrateLegacyApiKey(
  addApiKey: (name: string, key: string) => Promise<void>
): Promise<void> {
  try {
    const oldSettings = localStorage.getItem('creanizer-settings')
    if (!oldSettings) return

    const parsed = JSON.parse(oldSettings)
    if (!parsed.state?.geminiApiKey) return

    const existingKeys = await indexedDBManager.getApiKeys()
    if (existingKeys.length === 0) {
      await addApiKey('移行されたAPIキー', parsed.state.geminiApiKey)
    }
    localStorage.removeItem('creanizer-settings')
  } catch (error) {
    console.error('Failed to migrate from localStorage:', error)
  }
}
